'use client'

import { useEffect } from 'react'

export default function InertPolyfill() {
  useEffect(() => {
    void import('wicg-inert')
  }, [])

  return null
}
